/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { useMount } from 'react-use';

import { useMediaTagList, useMediaTag } from '@api/hooks';

import SearchableEntitySelect from '../SearchableEntitySelect';

const MediaTagSelect = ({ placeholder = 'Start typing a tag...', defaultValue, value, ...props }) => {
  const { data: defaultMediaTag, refetch } = useMediaTag(defaultValue, { manual: true });

  useMount(() => defaultValue && refetch());

  return (
    <SearchableEntitySelect
      placeholder={placeholder}
      useList={useMediaTagList}
      value={defaultMediaTag || value}
      formatLabel={({ tag }) => tag}
      {...props}
    />
  );
};

export default MediaTagSelect;
